module.exports = __webpack_public_path__ + "static/media/eastlogo1.b79e99b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/eastlogo1.jpg
// module id = 998
// module chunks = 8